export const COURSE_CATEGORIES = [
  "Education",
  "Business & Economics",
  "Science & Technology",
  "Self-Help",
  "Religion & Spirituality",
  "Health & Fitness",
  "Psychology",
];
